module.exports = __webpack_public_path__ + "img/shop4_1_m.22edfcea.png";